module.exports = __webpack_public_path__ + "media/images/front/about/about_header_bg-f08dc6b031006f1dae3db13ba55029fb.jpg";